<template>
  <v-dialog v-model="dialog" persistent width="600" max-width="100%">
    <v-card>
      <v-card-title class="text-h5 primary lighten-3">Aceitar Termos</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="handleNotAcceptTerms">Não aceitar</v-btn>
        <v-btn color="primary darken-1" text @click="handleAcceptTerms">Aceitar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { confirmAcceptTerms } from '@/services/authentication';

export default {
  props: {
    dialog: { type: Boolean, default: false },
    message: { type: String, default: undefined }
  },

  methods: {
    handleNotAcceptTerms() {
      this.$store.dispatch('authentication/logoff');
    },

    async handleAcceptTerms() {
      await confirmAcceptTerms();

      this.$emit('handleLogin');
    }
  }
};
</script>
